<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path
      d="M21.5 11.5c-.5.4-1.16.6-1.87.6-1.6 0-2.9-1.3-2.9-2.9 0-.7.2-1.4.6-1.87C15.7 4.05 13.9 3.5 12 3.5c-5.5 0-9.5 4-9.5 9s4 9 9.5 9 9.5-4 9.5-9c0-.4 0-.7-.05-1z"
      fill="currentColor"
      fill-opacity="0.18"
    />
    <circle
      cx="8.5"
      cy="11"
      r="1.1"
      fill="currentColor"
      stroke="none"
    />
    <circle
      cx="14"
      cy="15"
      r="1.1"
      fill="currentColor"
      stroke="none"
    />
    <circle
      cx="15"
      cy="9"
      r="0.85"
      fill="currentColor"
      stroke="none"
    />
    <circle
      cx="10"
      cy="15.5"
      r="0.75"
      fill="currentColor"
      stroke="none"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCookie',
  props: {
    size: { type: [String, Number], default: 18 },
    strokeWidth: { type: [String, Number], default: 1.8 },
  },
};
</script>
